@if ( isRejectDialog && !canDeactivateDialog && !confirmColleagues && !companySetupInfoPopup && !submitCompanySetupInfo
&& !confirmAmendAnswers ) {
<div class="content">
  <div class="title">{{ dialog.title }}</div>
  @if (dialog.message) {
  <div class="message" [innerHTML]="dialog.message"></div>
  } @if (!data.companyReject) {
  <div class="custom-form">
    <div class="control-box">
      <textarea class="input-form textarea" [(ngModel)]="data.message" placeholder="message"></textarea>
    </div>
  </div>
  } @if (data.companyReject) {
  <div>
    <div class="setup-form custom-form" [formGroup]="rejectCompanyForm">
      <div class="control-group">
        <div class="label">{{ rejectCompanyContent["REASON"] }}</div>
        <div class="control-box">
          <textarea class="input-form textarea" formControlName="message"></textarea>
        </div>
      </div>
      @if ( !rejectCompanyForm?.get('message')?.valid && rejectCompanyForm?.get('message')?.value === '' &&
      (rejectCompanyForm?.get('message')?.touched || rejectCompanyForm?.get('message')?.dirty) ) {
      <div class="error">
        {{ rejectCompanyContent["REASON_ERROR"] }}
      </div>
      }
      <div class="sub-title">{{ rejectCompanyContent["OPTIONAL_TEXT"] }}</div>
      <div class="control-group">
        <div class="label">{{ rejectCompanyContent["FIRST_NAME"] }}</div>
        <div class="control-box">
          <input class="input-form" type="text" formControlName="firstName" dddAppCapitalize />
        </div>
      </div>
      <div class="control-group">
        <div class="label">{{ rejectCompanyContent["LAST_NAME"] }}</div>
        <div class="control-box">
          <input class="input-form" type="text" formControlName="lastName" dddAppCapitalize />
        </div>
      </div>
      <div class="control-group">
        <div class="label">{{ rejectCompanyContent["EMAIL"] }}</div>
        <div class="control-box">
          <input class="input-form" type="text" formControlName="email" />
        </div>
      </div>
      @if ( !rejectCompanyForm?.get('email')?.valid && rejectCompanyForm?.get('email')?.value !== '' &&
      (rejectCompanyForm?.get('email')?.touched || rejectCompanyForm?.get('email')?.dirty) ) {
      <div class="error">
        {{ rejectCompanyContent["EMAIL_ERROR"] }}
      </div>
      }
    </div>
  </div>
  }
  <div class="actions">
    <button class="ddd-button" (click)="dialogRef.close(false)">
      {{ dialog.cancel }}
    </button>
    @if (!data.companyReject) {
    <button class="ddd-button raised" (click)="checkMessageOnClose(data.message)">
      {{ dialog.okBtn }}
    </button>
    } @if (data.companyReject) {
    <button
      class="ddd-button raised"
      (click)="dialogRef.close(rejectCompanyForm?.value)"
      [disabled]="!rejectCompanyForm?.valid"
    >
      {{ dialog.okBtn }}
    </button>
    }
  </div>
</div>
} @if ( !isRejectDialog && !canDeactivateDialog && !confirmColleagues && !companySetupInfoPopup &&
!submitCompanySetupInfo && !confirmAmendAnswers ) { @if (!data.newDesign) {
<div class="content">
  <div class="title">{{ dialog.title }}</div>
  @if (dialog.message !== 'input') {
  <div class="message" [innerHTML]="dialog.message"></div>
  } @if (dialog.message === 'input') {
  <div class="template-name-input">
    <input class="ddd-input" [formControl]="templateNameInput" />
  </div>
  } @if (dialog.extraMessage) {
  <div class="message">
    {{ dialog.extraMessage }}
  </div>
  }
  <div class="actions">
    @if (dialog.cancel) {
    <button class="ddd-button" (click)="dialogRef.close()">
      {{ dialog.cancel }}
    </button>
    } @if (dialog.message !== 'input') {
    <button class="ddd-button raised" (click)="dialogRef.close(true)">
      {{ dialog.okBtn }}
    </button>
    } @if (dialog.message === 'input') {
    <button class="ddd-button raised" (click)="dialogRef.close(templateNameInput.value)">
      {{ dialog.okBtn }}
    </button>
    }
  </div>
</div>
} @if (data.newDesign) {
<div>
  <header class="ddd-dialog-header">
    <div class="dialog-title">{{ dialog.title }}</div>
  </header>
  <div class="ddd-dialog-main">
    <div class="dialog-message" [innerHTML]="dialog.message"></div>
  </div>
  <footer class="ddd-dialog-footer end">
    <button class="ddd-button" (click)="dialogRef.close()">
      {{ dialog.cancel }}
    </button>
    <button class="ddd-button raised" (click)="dialogRef.close(true)">
      {{ dialog.okBtn }}
    </button>
  </footer>
</div>
} } @if ( !isRejectDialog && canDeactivateDialog && !confirmColleagues && !companySetupInfoPopup &&
!submitCompanySetupInfo && !confirmAmendAnswers ) {
<div class="content">
  <div class="title">{{ canDeactivateDialog.title }}</div>
  <div class="message">{{ canDeactivateDialog.message }}</div>
  <div class="actions">
    @if (dialog.cancel) {
    <button class="ddd-button" (click)="dialogRef.close(false)">
      {{ canDeactivateDialog.cancel }}
    </button>
    }
    <button class="ddd-button raised" (click)="dialogRef.close(true)">
      {{ canDeactivateDialog.okBtn }}
    </button>
  </div>
</div>
} @if ( !isRejectDialog && !canDeactivateDialog && confirmColleagues && !companySetupInfoPopup &&
!submitCompanySetupInfo && !confirmAmendAnswers ) {
<div class="content">
  <div class="title">
    {{ confirmColleaguesDialog.title }}
  </div>
  @for (invitedUser of data.invitedColleagues; track invitedUser) {
  <ul class="colleagues-invited">
    <li>
      {{ invitedUser.firstName }} {{ invitedUser.lastName }},
      {{ invitedUser.email }}
    </li>
  </ul>
  }
  <div class="actions">
    <button class="ddd-button raised" (click)="dialogRef.close()">
      {{ confirmColleaguesDialog.okBtn }}
    </button>
  </div>
</div>
} @if ( !isRejectDialog && !canDeactivateDialog && !confirmColleagues && companySetupInfoPopup &&
!submitCompanySetupInfo && !confirmAmendAnswers ) {
<div class="content">
  <div class="title">
    {{ companySetupInfoPopupDialog.title }}
  </div>
  <div class="message company-setup" [innerHTML]="companySetupInfoPopupDialog.message"></div>
  <div class="actions">
    <button class="ddd-button raised" (click)="dialogRef.close()">
      {{ companySetupInfoPopupDialog.okBtn }}
    </button>
  </div>
</div>
} @if ( !isRejectDialog && !canDeactivateDialog && !confirmColleagues && !companySetupInfoPopup &&
submitCompanySetupInfo && !confirmAmendAnswers ) {
<div class="content">
  <div class="title">{{ submitCompanySetupInfoDialog.title }}</div>
  <div class="message">{{ submitCompanySetupInfoDialog.message }}</div>
  <div class="actions">
    <button class="ddd-button" (click)="dialogRef.close()">
      {{ submitCompanySetupInfoDialog.cancel }}
    </button>
    <button class="ddd-button raised" (click)="dialogRef.close(true)">
      {{ submitCompanySetupInfoDialog.okBtn }}
    </button>
  </div>
</div>
} @if ( !isRejectDialog && !canDeactivateDialog && !confirmColleagues && !companySetupInfoPopup &&
!submitCompanySetupInfo && confirmAmendAnswers ) {
<div class="content">
  <div class="title">{{ confirmAmendAnswersDialog.title }}</div>
  <div class="message">{{ confirmAmendAnswersDialog.message }}</div>
  <div class="actions">
    <button class="ddd-button" (click)="dialogRef.close()">
      {{ confirmAmendAnswersDialog.cancel }}
    </button>
    <button class="ddd-button raised" (click)="dialogRef.close(true)">
      {{ confirmAmendAnswersDialog.okBtn }}
    </button>
  </div>
</div>
}
